import { authenticationConstants as authC } from 'srcReact/redux/constants/authentication'

const initialState = {
  newEmail: '',
  checkEmail: {},
  checkEmailLoading: false,
  checkEmailSentOnce: false,
  checkEmailError: null,
  checkEmailAlreadyUsed: false,
  isResend: false,
  resendActivationCodeSent: false,
  resendActivationCodeLoading: false,
  validateActivationCodeLoading: false,
  validateActivationCodeValidated: 'not_sent',
  createAccountLoading: false,
  createAccountResponse: {
    access_token: '',
    interests: [],
    workplaces: [],
    user: {
      firstname: '',
      lastname: ''
    }
  },
  createAccountError: '',
  passwordResetLinkSentLoading: false,
  passwordResetLinkSent: false,
  passwordResetLinkError: false,
  passwordResetLinkErrorMessage: '',
  checkResetKeyLoading: false,
  resetKeyChecked: false,
  resetPasswordEmail: '',
  updatePasswordLoading: false,
  updatePasswordSuccess: false,
  updatePasswordError: '',
  ssoUser: null,
  authExternalApp: {
    loading: false,
    success: false,
    error: '',
    redirectUrl: ''
  }
}

export function authentication(state = initialState, action) {
  switch (action.type) {
    case authC.CHECK_EMAIL_REQUEST:
      return {
        ...state,
        newEmail: '',
        checkEmail: { isRegistered: null },
        checkEmailLoading: true,
        checkEmailAlreadyUsed: false,
        checkEmailError: null
      }
    case authC.CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        newEmail: action.datas && action.datas.email,
        checkEmail: action.datas,
        checkEmailLoading: false,
        checkEmailError: null,
        checkEmailAlreadyUsed: action.datas.isRegistered === 1
      }
    case authC.CHECK_EMAIL_FAILURE:
      return {
        ...state,
        newEmail: '',
        checkEmailLoading: false,
        checkEmailAlreadyUsed: false,
        checkEmailError: action.error
      }

    case authC.SEND_ACTIVATION_CODE_REQUEST:
      return {
        ...state,
        resendActivationCodeLoading: true,
        checkEmailSentOnce: true,
        resendActivationCodeSent: false,
        isResend: action.isResend
      }
    case authC.SEND_ACTIVATION_CODE_SUCCESS:
      return { ...state, resendActivationCodeLoading: false, resendActivationCodeSent: true }
    case authC.SEND_ACTIVATION_CODE_FAILURE:
      return { ...state, resendActivationCodeLoading: false, resendActivationCodeSent: false }

    case authC.VALIDATE_ACTIVATION_CODE_REQUEST:
      return { ...state, validateActivationCodeLoading: true }
    case authC.VALIDATE_ACTIVATION_CODE_SUCCESS:
      let hasBeenValidated = action.response.hasBeenValidated === 1
      return { ...state, validateActivationCodeLoading: false, validateActivationCodeValidated: hasBeenValidated }
    case authC.VALIDATE_ACTIVATION_CODE_FAILURE:
      hasBeenValidated =
        action && action.error && action.error.message
          ? action.error.message.includes('has already been validated') ||
            action.error.message.includes('email is linked to a user account')
          : true

      return { ...state, validateActivationCodeLoading: false, validateActivationCodeValidated: hasBeenValidated }

    case authC.CREATE_ACCOUNT_REQUEST:
      return { ...state, createAccountLoading: true, createAccountError: '' }
    case authC.CREATE_ACCOUNT_SUCCESS:
      return { ...state, createAccountResponse: action.response, createAccountLoading: false, createAccountError: '' }
    case authC.CREATE_ACCOUNT_FAILURE: {
      return { ...state, createAccountLoading: false, createAccountError: action.error || action.error.message }
    }

    case authC.SEND_PASSWORD_RESET_LINK_REQUEST:
      return { ...state, passwordResetLinkSentLoading: true, passwordResetLinkErrorMessage: '' }
    case authC.SEND_PASSWORD_RESET_LINK_SUCCESS:
      return {
        ...state,
        passwordResetLinkSentLoading: false,
        passwordResetLinkSent: true,
        passwordResetLinkError: false,
        passwordResetLinkErrorMessage: ''
      }
    case authC.SEND_PASSWORD_RESET_LINK_FAILURE:
      return {
        ...state,
        passwordResetLinkSentLoading: false,
        passwordResetLinkSent: false,
        passwordResetLinkError: true,
        passwordResetLinkErrorMessage: action.error ? action.error.message : ''
      }

    case authC.CHECK_PASSWORD_RESET_KEY_REQUEST:
      return { ...state, checkResetKeyLoading: true }
    case authC.CHECK_PASSWORD_RESET_KEY_SUCCESS:
      return { ...state, checkResetKeyLoading: false, resetKeyChecked: true, resetPasswordEmail: action.response.email }
    case authC.CHECK_PASSWORD_RESET_KEY_FAILURE:
      return { ...state, checkResetKeyLoading: false, resetKeyChecked: false }

    case authC.UPDATE_PASSWORD_REQUEST:
      return { ...state, updatePasswordLoading: true, updatePasswordError: '' }
    case authC.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatePasswordLoading: false,
        updatePasswordSuccess: true,
        passwordResetLinkError: false,
        updatePasswordError: ''
      }
    case authC.UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        updatePasswordLoading: false,
        updatePasswordSuccess: false,
        passwordResetLinkError: true,
        updatePasswordError: action.error && action.error && action.error.message
      }

    case authC.GET_SSO_USER_INFO_REQUEST:
      return { ...state }
    case authC.GET_SSO_USER_INFO_SUCCESS:
      return { ...state, ssoUser: action.response }
    case authC.GET_SSO_USER_INFO_FAILURE:
      return { ...state }

    case authC.LOGIN_WITH_APP_REQUEST:
      return {
        ...state,
        authExternalApp: {
          ...state.authExternalApp,
          loading: true
        }
      }
    case authC.LOGIN_WITH_APP_SUCCESS:
      return {
        ...state,
        authExternalApp: {
          ...state.authExternalApp,
          loading: false,
          success: true,
          redirectUrl: action.response.redirect_url,
          error: ''
        }
      }
    case authC.LOGIN_WITH_APP_FAILURE:
      return {
        ...state,
        authExternalApp: {
          ...state.authExternalApp,
          loading: false,
          success: false,
          error: action.error
        }
      }

    default:
      return state
  }
}
